<template>
  <v-app id="inspire">
    <v-container fluid fill-height class="login-app">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <div class="login-brand">
            <img src="../../assets/ead-viamaker-white.svg" alt="Logo EAD Viamaker"/>

            <h2 v-if="inviteMode">Bem vindo ao Curso<br><strong v-if="course.title">{{ course.title }}</strong></h2>
          </div>

          <!-- LOGIN DE USUÁRIO -->
          <v-card v-if="!registerMode && !forgotPasswordMode">
            <v-card-title dark color="primary">
              <v-toolbar-title>Acesse sua conta</v-toolbar-title>
            </v-card-title>

            <v-card-text style="padding: 0 8px;">
              <v-form>
                <v-text-field
                  :readonly="emailReadOnly"
                  v-model="email"
                  label="Email"
                  placeholder="Digite seu email"
                  outlined
                  @keyup.enter="doLogin"
                ></v-text-field>

                <v-text-field
                  id="password"
                  v-model="password"
                  name="password"
                  label="Senha"
                  placeholder="Digite sua senha"
                  type="password"
                  outlined
                  class="mb-0"
                  @keyup.enter="doLogin"
                >
                </v-text-field>

                <a class="link" @click="forgotPassword">Esqueci minha senha</a>
              </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
              <v-btn @click="doLogin" class="btn-login" :class="showBtnSend ? '' : 'disabled'" color="primary"
                     :loading="sending">Entrar
              </v-btn>
            </v-card-actions>

            <!-- <p class="link">Não tem conta? <a @click="changeRegisterMode(true)" :class="showBtnSend ? '' : 'disabled'">Cadastre-se
              aqui</a></p> -->
            <v-alert type="success" v-model="alert.success" class="white-text" style="margin:0 8px;">
              Login efetuado com sucesso
            </v-alert>
            <v-alert type="error" v-model="alert.error" class="white-text" style="margin:0 8px;">
              Login / Senha inválidos
            </v-alert>
          </v-card>

          <!-- CADASTRO DE USUÁRIO -->
          <v-card class="elevation-12" v-if="registerMode">
            <v-card-title dark color="primary">
              <v-toolbar-title>Cadastro</v-toolbar-title>
            </v-card-title>

            <v-card-text style="padding: 0 8px;">
              <v-form ref="formRegister" v-model="valid" lazy-validation>

                <v-text-field
                  v-model="name"
                  label="Nome"
                  placeholder="Seu nome"
                  :rules="rules.name"
                  outlined
                  required
                  @keyup.enter="doRegister"
                ></v-text-field>

                <v-text-field
                  :readonly="emailReadOnly"
                  v-model="email"
                  label="Email"
                  :rules="rules.email"
                  placeholder="Digite seu email"
                  outlined
                  required
                  @keyup.enter="doRegister"
                ></v-text-field>

                <v-text-field
                  v-model="password"
                  label="Senha"
                  placeholder="Digite uma senha"
                  type="password"
                  :rules="rules.password"
                  outlined
                  required
                  @keyup.enter="doRegister"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
              <v-btn class="btn-login mb-5" @click="doRegister" :class="showBtnSend ? '' : 'disabled'" color="primary"
                     :loading="sending">Cadastrar
              </v-btn>
            </v-card-actions>
            <p class="link">Já possuí uma conta? <a @click="changeRegisterMode(false)"
                                                    :class="showBtnSend ? '' : 'disabled'">Fazer login</a></p>

            <v-alert type="success" v-model="alert.success">
              Cadastro efetuado com sucesso
            </v-alert>
            <v-alert type="error" v-model="alert.error">
              Erro ao cadastrar
            </v-alert>
          </v-card>

          <!-- Esqueci minha senha -->
          <v-card class="elevation-12" v-if="forgotPasswordMode">
            <v-card-title dark color="primary">
              <v-btn class="btn-login-back" @click="changeRegisterMode(false)" :class="showBtnSend ? '' : 'disabled'"
                     small>Voltar
              </v-btn>
              <v-toolbar-title>Esqueci minha senha</v-toolbar-title>
            </v-card-title>

            <v-card-text style="padding: 0 8px;">
              <v-form ref="formForgotPassword" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="email"
                  label="Email"
                  :rules="rules.email"
                  placeholder="Digite seu email"
                  outlined
                  required
                ></v-text-field>
              </v-form>
            </v-card-text>

            <v-card-actions class="pb-3">
              <v-btn class="btn-login" @click="doForgotPassword" :class="showBtnSend ? '' : 'disabled'" color="primary"
                     :loading="sending">Recuperar senha
              </v-btn>
            </v-card-actions>
            <v-alert type="success" v-model="alert.success">
              Um email de recuperação foi enviado
            </v-alert>
            <v-alert type="error" v-model="alert.error">
              Erro ao recuperar
            </v-alert>
          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="showAlert"
      :top="true"
      :color="colorAlert"
    >
      <span style="color: #fff;">
        {{ textAlert }}
      </span>
      <v-btn
        v-if="!showBtnWarningLogin"
        class="btn-outline-white"
        text
        @click="showAlert = false">
        Fechar
      </v-btn>

      <v-btn
        v-if="showBtnWarningLogin"
        class="btn-outline-white"
        text
        @click="alertMakeLogin">
        Fazer login
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import { encrypt } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: () => ({
    valid: true,
    email: null,
    password: null,
    name: null,

    emailReadOnly: false,

    course: {},

    showAlert: false,
    textAlert: '',
    colorAlert: '',
    showBtnWarningLogin: false,

    registerMode: false,
    showBtnSend: true,
    forgotPasswordMode: false,
    info: null,
    alert: {
      success: false,
      error: false
    },
    sending: false,
    rules: {
      name: [
        v => !!v || 'Preencha seu nome'
      ],
      email: [
        v => !!v || 'Preencha seu email',
        v => /.+@.+/.test(v) || 'Email inválido'
      ],
      password: [
        v => !!v || 'Preencha a senha',
        v => (v && v.length >= 6) || 'A senha precisa ter pelo menos 6 caracteres'
      ]
    }
  }),
  computed: {
    ...mapGetters(['getCurseEnter']),
    inviteMode: function () {
      if (this.$route.params.token) {
        return true
      }

      return false
    }
  },
  watch: {
    showAlert (val) {
      if (!val) {
        this.textAlert = ''
        this.colorAlert = ''
        this.showBtnWarningLogin = false
      }
    }
  },
  methods: {
    ...mapActions(['setToken', 'setUser', 'setUserPermissions']),

    validate () {
      return this.$refs.formRegister.validate()
    },

    forgotPassword () {
      this.forgotPasswordMode = true
      this.forgotPasswordMode = true
    },

    alertMakeLogin () {
      this.showAlert = false
      this.registerMode = false
    },

    doRegister () {
      if (this.validate()) {
        this.sending = true
        const encryptObj = encrypt(this.password)

        const data = {
          name: this.name,
          token: this.$route.params.token,
          password: encryptObj.ciphertext,
          buffer: encryptObj.nonce
        }

        if (!this.inviteMode) {
          data.email = this.email
        }

        if (this.getCurseEnter) {
          data.courseSlug = this.getCurseEnter
        }

        this.axios.request({
          method: 'POST',
          url: (this.inviteMode ? '/public/user/token' : '/public/user/create'),
          data
        }).then(response => {
          if (response.data.success) {
            this.setUserData(response.data.user)

            this.showAlert = true
            this.colorAlert = 'success'
            this.textAlert = (this.inviteMode ? 'Bem vindo ao Curso' : 'Bem vindo ao EAD Viamaker')

            setTimeout(() => {
              this.$router.push({ name: 'home' })
            }, 2000)
          } else {
            this.showBtnWarningLogin = true
            this.colorAlert = 'warning'
            this.textAlert = (response.data.message ? response.data.message : 'Erro ao cadastrar')
            this.showAlert = true
          }
        }).finally(() => {
          this.sending = false
        })
      }
    },

    doForgotPassword () {
      const data = {
        email: this.email
      }

      if (this.$route.params.token) {
        data.tokenInvite = this.$route.params.token
      }

      this.sending = true

      /* eslint-disable no-undef */
      grecaptcha.ready(() => {
        grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY_SITE, { action: 'submit' }).then(token => {
          data.token = token

          this.axios.post('/public/forgot-password/', data).then(response => {
            if (response.data.success) {
              this.alert.success = true
            } else {
              this.alert.error = true
            }
          }).catch(() => {
            this.alert.error = true
          }).finally(() => {
            this.sending = false
          })
        }).catch(err => {
          console.error(err)

          this.showAlert = true
          this.colorAlert = 'error'
          this.textAlert = 'Erro ao buscar o reCaptcha'
        })
      })

    },

    getCourseInvite () {
      const token = this.$route.params.token

      this.axios.get(`/public/course-invite/token/${token}`).then(response => {
        if (response.data.success && response.data.courseInvite.course) {
          this.course = response.data.courseInvite.course
          this.email = response.data.courseInvite.email
          this.emailReadOnly = true
        }
      })
    },

    setUserData (returnUserData) {
      this.setToken(returnUserData.token)
      this.setUser({ name: returnUserData.name, id: returnUserData._id, thumb: (returnUserData.thumb || null) })

      this.setUserPermissions(returnUserData.permission)
    },

    doLogin () {
      this.showAlert = false

      if (!this.password) {
        this.textAlert = 'Preencha a senha'
        this.colorAlert = 'warning'
        this.showAlert = true

        return false
      }

      this.sending = true

      /* eslint-disable no-undef */
      grecaptcha.ready(() => {
        grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY_SITE, { action: 'submit' }).then(token => {

          let encryptObj = encrypt(this.password)

          let payload = {
            token,
            login: this.email,
            password: encryptObj.ciphertext,
            buffer: encryptObj.nonce
          }

          this.sending = true

          this.axios.post('/public/login', payload).then(({ data }) => {
            if (data.success && data.user) {
              this.colorAlert = 'success'
              this.textAlert = 'Login efetuado com sucesso'

              this.setUserData(data.user)

              if (this.inviteMode) {
                this.axios.request({
                  method: 'post',
                  url: '/course-invite/accept',
                  data: { token: this.$route.params.token },
                  headers: {
                    Authorization: `Bearer ${data.user.token}`,
                    'Content-Type': 'application/json'
                  }
                }).then(response => {
                  if (response.data.success) {
                    this.colorAlert = 'success'
                    this.textAlert = 'Bem vindo ao Curso'

                    setTimeout(() => {
                      this.$router.push({ name: 'home' })
                    }, 2000)
                  }
                }).catch(err => {
                  console.error(err)

                  this.colorAlert = 'error'
                  this.textAlert = 'Erro ao entrar no curso'
                })
              } else {
                setTimeout(() => {
                  this.$router.push({ name: 'home' })
                }, 2000)
              }
            } else {
              this.colorAlert = 'error'
              this.textAlert = 'Usuário não encontrado'
            }
          }).catch(err => {
            console.error(err)

            this.colorAlert = 'error'
            this.textAlert = 'Erro ao efetuar o login'
          }).finally(() => {
            this.sending = false
            this.showAlert = true
          })
        }).catch(err => {
          console.error(err)

          this.showAlert = true
          this.colorAlert = 'error'
          this.textAlert = 'Erro ao buscar o reCaptcha'
        })
      })
    },

    changeRegisterMode (mode) {
      if (!mode && this.$refs.formRegister) {
        this.$refs.formRegister.resetValidation()
      }

      this.registerMode = mode
      this.forgotPasswordMode = false
    }
  },
  created () {
    if (this.$route.params.token) {
      this.getCourseInvite()
    }
  }
}
</script>
